import type { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';
import { CloseButton } from '~/components/common/modal/CloseButton';
import { CommonBasicModal } from '~/components/common/modal/CommonBasicModal';
import { px } from '~/styles/ts/functions';

const ModalContainer = styled.div`
  position: relative;
`;

const CloseButtonPosition = styled.div`
  position: absolute;
  bottom: ${px(-120)};
  right: 0;
  left: 0;
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: center;

  svg {
    transform: scale(0.5);
  }
`;

type Props = ComponentPropsWithoutRef<typeof CommonBasicModal>;

export const CommonUnderCloseModal = ({ children, onClick, size }: Props) => {
  return (
    <ModalContainer>
      <CommonBasicModal size={size} onClick={onClick}>
        <>{children}</>
        <CloseButtonPosition>
          <CloseButton onClick={onClick} strokeColor="white" iconType="circle" />
        </CloseButtonPosition>
      </CommonBasicModal>
    </ModalContainer>
  );
};
